module.exports = __webpack_public_path__ + "img/deadline.1731b07c.png";